import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getTestQuestions,
  questionSaveAndNext,
} from "../../redux/test/actions";

const useViewSolution = () => {
  const testResult = useSelector((state) => state.performance.performance.data);
  const testQuestions = useSelector((state) => state.test.testQuestions?.data);
  const totalQuestion = useSelector(
    (state) => state.test.questionSummary?.totalQuestion
  );
  const current = useSelector((state) => state.test.questionSummary?.current);
  const index = useSelector((state) => state.test.questionSummary?.index);
  const questionsInfoSummary = useSelector(
    (state) => state.test.questionSummary?.questionsInfo
  );

  const { parent } = useParams();
  const dispatch = useDispatch();

  const renderOptionsList = (data) => {
    const questionOpt = Array.from({ length: 5 }, (_, i) => {
      const opt = data[`Opt${i + 1}`];
      return opt ? { text: opt, id: i + 1 } : null;
    }).filter(Boolean);

    return questionOpt;
  };

  const getUserAnswer = (id, i) => {
    const submitAns = testResult?.TestAnsweredPtr?.SubmittedAnswers?.filter(
      (x) => x?.TestQuestionsPtr?.objectId == id
    );
    if (submitAns?.length) {
      if (submitAns[0]?.SubmittedAnswer?.includes(i)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const previousHandler = (num) => {
    dispatch(
      questionSaveAndNext({
        questionsInfo: questionsInfoSummary,
        current: num - 1,
        index: num,
      })
    );
  };

  const nextHandler = (num, id) => {
    let current = totalQuestion === num + 1 ? num : num + 1;
    let index = totalQuestion === current ? current : current + 1;

    dispatch(
      questionSaveAndNext({
        questionsInfo: questionsInfoSummary,
        current,
        index,
      })
    );
  };

  useEffect(() => {
    if (parent) {
      dispatch(getTestQuestions(parent));
    }
  }, []);

  return {
    current,
    index,
    testResult,
    testQuestions,
    renderOptionsList,
    previousHandler,
    nextHandler,
    getUserAnswer,
  };
};

export default useViewSolution;
